<template>
  <div class="dropdown">
    <button 
      class="btn btn-sm btn-link text-decoration-none dropdown-toggle-custom" 
      type="button"
      data-toggle="dropdown" 
      aria-haspopup="true" 
      aria-expanded="false"
      title="Opciones"
    >
      <i class="fas fa-cog fa-lg"></i>
    </button>

    <div class="dropdown-menu dropdown-menu-right shadow border-0">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
</script>

<style scoped>
.dropdown-toggle-custom {
  color: #6c757d;
  transition: all 0.3s ease;
}

.dropdown-toggle-custom:hover,
.dropdown-toggle-custom[aria-expanded="true"] {
  color: #0d6efd;
  transform: rotate(90deg);
}

.dropdown-toggle-custom::after {
  display: none;
}
</style>